// extracted by mini-css-extract-plugin
module.exports = {"module":"object-page_module__2OGf1","content":"object-page_content__mlm-V"};